import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=386ebe79&scoped=true&"
import script from "./AdminTemplate.vue?vue&type=script&lang=js&"
export * from "./AdminTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AdminTemplate.vue?vue&type=style&index=0&id=386ebe79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ebe79",
  null
  
)

export default component.exports